import React from 'react';

import Icon, { IconProps } from './icon';
import { ReactProps } from '../../typings/common-types';

const svg = (props: ReactProps) => (
  <svg
    aria-hidden="true"
    role="presentation"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <g>
      <g>
        <path d="M0.6,8.7C0.3,8.7,0,8.4,0,8c0-4.4,3.6-8,8-8c2.3,0,4.5,1,6,2.7c0.2,0.3,0.2,0.7-0.1,0.9c-0.3,0.2-0.7,0.2-0.9-0.1c-1.3-1.4-3.1-2.3-5-2.3c-3.7,0-6.7,3-6.7,6.7C1.3,8.4,1,8.7,0.6,8.7z" />
      </g>
      <g>
        <path d="M14.1,4.5c-0.4,0-0.6-0.3-0.6-0.6V1.3c0-0.4,0.3-0.6,0.6-0.6c0.4,0,0.6,0.3,0.6,0.6v2.6C14.7,4.2,14.4,4.5,14.1,4.5z" />
      </g>
      <g>
        <path d="M14.1,4.5l-2.6,0c-0.4,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6l2.6,0c0.4,0,0.6,0.3,0.6,0.6S14.4,4.5,14.1,4.5z" />
      </g>
      <g>
        <path d="M8,16c-2.3,0-4.5-1-6-2.7c-0.2-0.3-0.2-0.7,0.1-0.9c0.3-0.2,0.7-0.2,0.9,0.1c1.3,1.4,3.1,2.3,5,2.3c3.7,0,6.7-3,6.7-6.7c0-0.4,0.3-0.6,0.6-0.6C15.7,7.4,16,7.7,16,8C16,12.4,12.4,16,8,16z" />
      </g>
      <g>
        <path d="M1.9,15.4c-0.4,0-0.6-0.3-0.6-0.6l0-2.6c0-0.4,0.3-0.6,0.6-0.6c0.4,0,0.6,0.3,0.6,0.6v2.6C2.5,15.1,2.3,15.4,1.9,15.4z" />
      </g>
      <g>
        <path d="M4.5,12.8H1.9c-0.4,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6l2.6,0c0.4,0,0.6,0.3,0.6,0.6C5.1,12.5,4.8,12.8,4.5,12.8z" />
      </g>
    </g>
  </svg>
);

const IconRefresh: React.FC<IconProps> = (props: ReactProps) => <Icon {...props} svg={svg} />;

export default IconRefresh;
